<template>
  <div class="download-results">   
    <button id="downloadResultsBttn" 
      class="btn btn-link px-2"      
      @click.stop="downloadResults" :disabled="numResults < 1">
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>         
  </div>
</template>

<script>
//import {Actions} from '@/store/stateChanges'
export default {
  name: 'DownloadResults',
  data() {
    return {
     
    };
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    numResults () {
      return this.$store.state.numParallels
    }
  },
  methods: {
    downloadResults() {      
      var text = `<head> 
        <title>Parallel Results</title>
        <meta charset="utf-8"> 
        <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no">
        <link rel="icon" href="https://parallels.dicta.org.il/favicon.ico">
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/css/bootstrap.min.css"> 
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/css/bootstrap-grid.min.css">
        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet">
        <link href="https://fonts.googleapis.com/css2?family=David+Libre&display=swap" rel="stylesheet">
        <link href="https://fonts.googleapis.com/css?family=Arimo:400,700" rel="stylesheet">`
        text += `<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></` + `script>`
        text += `<style>  
        body {
          font-family: Roboto,Arimo,mft-narkisclassic,Avenir,Helvetica,sans-serif;
        }
        body.he {text-align:right;direction:rtl;}
        .url-wrap {text-align:right;}
        .he .url-wrap {text-align:left;}
        .logo-wrap {
            vertical-align: top;   
            width: 48px;             
          }
        .logo-wrap img {
          width: 100%;
          height: auto
        }  
        .footnote-num {right: 0;}
        .mb-0 {font-size: 18px;}  
        small {font-size: 14px;}
        .d-flex {display:block!important;}
        .custom-checkbox,
        .set-accuracy,
        .router-link-active,
        button.d-inline-block,
        button.d-md-inline-block,
        button:not(.to-top){
          display: none!important;
        }
        button.to-top {
          bottom:12px;
          right:50px;
          z-index: 99; 
          background-color: #e3e3e3;
          border-color: #e3e3e3;
          width: 50px;
        }	  
        </style>
        </head>`
      if (this.hebrew) {
        text += '<body class="he">'
      } else {
        text += '<body>'
      }
       text += `	<header class="container py-2">
      <div class="row">
      <div class="col-sm-6">
      <div class="logo-wrap d-inline-block">
        <img src="https://parallels.dicta.org.il/Logo_PasukFinder_Black_Circle.png" alt="logo" />
      </div>
      <div class="d-inline-block mx-1">
      `
      if (this.hebrew) {
        text +=`<p class="mb-0">איתור מקבילות</p>
        <small class="mt-n1 d-block">דיקטה - כלים דיגיטליים לעיבוד טקסטים עבריים </small>`
      } else {
          text +=`<p class="mb-0">Parallels Finder</p>
        <small class="mt-n1 d-block">Dicta -  Analytical tools for Hebrew texts</small>` 
      }  
      text +=`</div></div>
    
    <div class="col-sm-6 url-wrap">
      <a class="text-dark d-block" target="_blank" href="https://parallels.dicta.org.il">parallels.dicta.org.il</a>
    </div>
    </div>		
   </header>
   <div class="container">`
    text += document.getElementsByClassName('raised-frame')[0].innerHTML
    text += document.getElementsByClassName('raised-frame')[1].innerHTML
    text +=`</div>`
    text += `<script>
	  	jQuery(document).ready(function (e) {
        jQuery(".cursor-pointer").click(function() {
          var sentenceId = $(this).attr('id');
          if (sentenceId) {
            var rowNum = parseInt(sentenceId.split('-')[sentenceId.split('-').length-1])
            rows = document.getElementsByClassName("footnote-num"); 

            jQuery('html, body').animate({
              scrollTop: $(rows[rowNum]).offset().top
            }, 400);
          }
        });
        jQuery(window).scroll(function() {
          if ($(this).scrollTop() > 140) {
            jQuery('.to-top').fadeIn();
          } else {
            jQuery('.to-top').fadeOut();
          }
        });
        jQuery('.to-top').on('click', function(e){
          jQuery("html, body").animate({scrollTop: 0}, 500);
          return false;
        });        
      });
      <` + `/` + `script>`
       text += `
       <button class="btn position-fixed rounded to-top" style="display:none;">
        <i class="fa fa-chevron-up"></i>
      </button>
      </body></html>`
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
      element.setAttribute('download', 'ParallelResults.html')
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
